import request from '../../utils/request';

export const pickupPointService = {
    //提货点列表数据查询
    getPickupPointData: (data) => {
        return request({
            url: '/pickupPoint/list',
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
            data: data
        })
    },
    //提货点保存
    savePickupPoint: (data,method) => {
        let callUrl = "/pickupPoint/edit"
        if('add' === method){
            callUrl = "pickupPoint/new"
        }
        return request({
            url: callUrl,
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
            data: data
        })
    },
    //提货点删除
    deletePickupPoint: (data) => {
        return request({
            url: '/pickupPoint/del',
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
            data: data
        })
    },
}